"use client";

import { usePdpVariant } from "./PdpVariantContext";
import PdpComments from "./PdpComments";

type Props = {
    siteProductId: number;
};

export default function PdpCommentsSection({ siteProductId }: Props) {
    const { showProduct } = usePdpVariant();
    return <PdpComments product={showProduct} siteProductId={siteProductId} />;
}
